import { Button, Divider, Whisper, Tooltip } from "rsuite";
import styles from "./AttachedFiles.module.css";
import TrashIcon from "@rsuite/icons/Trash";
import AttachmentIcon from "@rsuite/icons/Attachment";
import PageIcon from "@rsuite/icons/Page";
import VisibleIcon from "@rsuite/icons/Visible";
import FileUploaderModal from "./Components/FileUploaderModal/FileUploaderModal";
import { useFileUploaderModal } from "./Components/FileUploaderModal/useFileUploaderModal";
import FilePreviewModal from "./Components/FilePreviewModal/FilePreviewModal";
import { useFilePreviewModal } from "./Components/FilePreviewModal/useFilePreviewModal";
import { usePurchaseOrders } from "../../../../usePurchaseOrders";
import {
  isFileAvaliableToDelete,
  isFilesAvaliableToAdd,
} from "../../../../../../helperFunctions";

function AttachedFiles() {
  const { showFileUploaderModal } = useFileUploaderModal();
  const { form } = usePurchaseOrders.getState();
  const { deleteAttachedFile } = usePurchaseOrders();

  const files = form.attachedFiles || [];
  const canAddFiles = isFilesAvaliableToAdd(form.status);

  return (
    <>
      <Divider />
      <div className={styles.container}>
        <section className={styles.header_container}>
          <div className={styles.title}>
            Attached files
            {files.length > 0 && (
              <span className={styles.count_badge}>{files.length}</span>
            )}
          </div>
          {canAddFiles && (
            <Button
              onClick={showFileUploaderModal}
              color="blue"
              appearance="primary"
              startIcon={<AttachmentIcon />}
            >
              Add files
            </Button>
          )}
        </section>

        <div className={styles.files_container}>
          {files.length === 0 ? (
            <div className={styles.empty_state}>
              <PageIcon style={{ fontSize: 22 }} />
              <span>No files attached yet</span>
            </div>
          ) : (
            files.map((file) => (
              <File
                key={file?.id}
                orderStatus={form?.status}
                name={file?.fileName}
                url={file?.url}
                onDelete={() => {
                  deleteAttachedFile(file?.id);
                }}
              />
            ))
          )}
        </div>
        <Divider />
      </div>

      <FileUploaderModal />
      <FilePreviewModal />
    </>
  );
}

export default AttachedFiles;

const getExtension = (name) => {
  if (!name || typeof name !== "string") return "";
  const parts = name.split(".");
  return parts.length > 1 ? parts.pop() : "";
};

const File = ({ name, url, onDelete, orderStatus }) => {
  const avaliableToDelete = isFileAvaliableToDelete(orderStatus);
  const ext = getExtension(name);
  const { showFilePreview } = useFilePreviewModal();

  const openPreview = () => showFilePreview({ name, url });

  return (
    <div className={styles.file_container}>
      <div className={styles.file_icon}>
        <PageIcon />
      </div>
      <div className={styles.file_meta}>
        <span
          className={styles.file_name}
          onClick={openPreview}
          role="button"
          tabIndex={0}
        >
          {name}
        </span>
        {ext && <span className={styles.file_ext}>{ext}</span>}
      </div>
      <div className={styles.file_actions}>
        <Whisper
          placement="top"
          trigger="hover"
          speaker={<Tooltip>Preview file</Tooltip>}
        >
          <div
            className={styles.action_btn}
            onClick={openPreview}
            role="button"
            tabIndex={0}
          >
            <VisibleIcon />
          </div>
        </Whisper>
        {avaliableToDelete && (
          <Whisper
            placement="top"
            trigger="hover"
            speaker={<Tooltip>Delete file</Tooltip>}
          >
            <div
              className={`${styles.action_btn} ${styles.delete_btn}`}
              onClick={onDelete}
            >
              <TrashIcon />
            </div>
          </Whisper>
        )}
      </div>
    </div>
  );
};
